import React, { Component } from 'react';
import { Loading } from "./Loading"
import { AdminVoteLiveResultPuller } from './AdminVoteLiveResultPuller';
import { AdminVoteControll } from '../../until925/components/AdminVoteController';
import { AdminVoteResultDisplay } from '../../until925/components/AdminVoteResultDisplay';

export class AdminResultControlWrapper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentActiveShow: false,
            currentActivePoll: false,
            currentActiveShowID: 0,
            recentPollID: 0,
            aVoteCount: 0,
            bVoteCount: 0,
            voteType: 0,
            noisyPeeps: [],
            loading: true
        };

        this.rerenderParentCallback = this.rerenderParentCallback.bind(this);
    }

    componentDidMount() {
        this.getPoll()
    }

    async getPoll() {
        const response = await fetch('api/getPollInfo');
        const data = await response.json();
        this.setState({
            currentActiveShow: data["value"]["openShow"],
            currentActivePoll: data["value"]["openVote"],
            currentActiveShowID: data["value"]["activeShowId"],
            recentPollID: data["value"]["recentPollId"],
            aVoteCount: data["value"]["aVoteCount"],
            bVoteCount: data["value"]["bVoteCount"],
            voteType: data["value"]["voteType"],
            noisyPeeps: data["value"]["noisypeeps"],
            loading: false
        });
    }

    async rerenderParentCallback() {
        await this.getPoll();
        this.forceUpdate();
    }

    render() {
        const controls = this.props.activeControls;
        const loading = (this.state.loading);
        const activeShow = (this.state.currentActiveShow);
        const activePoll = (this.state.currentActivePoll);
        const activeShowId = (this.state.currentActiveShowID);
        const previousPole = (this.state.recentPollID > 0) ? true : false;
        const voteA = (this.state.aVoteCount);
        const voteB = (this.state.bVoteCount);
        const voteType = (this.state.voteType);
        const noisyPeeps = (this.state.noisyPeeps);

        let controllComponent;
        if (loading) { controllComponent = <Loading /> }
        else if (controls) {
            controllComponent = <AdminVoteControll
                activeShowId={activeShowId}
                activeShow={activeShow}
                activePoll={activePoll}
                rerenderParentCallback={this.rerenderParentCallback}
            />
        }
        else {
            controllComponent = <br />
        }

        let resultComponent;
        if (activeShow && activePoll) { resultComponent = <AdminVoteLiveResultPuller /> }
        else if (activeShow && previousPole) {
            resultComponent = <AdminVoteResultDisplay
                loading={false}
                ongoing={false}
                A_Vote={voteA}
                B_Vote={voteB}
                vote_Type={voteType}
                noisyPeeps={noisyPeeps}
            />
        }
        else { resultComponent = <br /> }

        return (
            <div>
                {resultComponent}
                {controllComponent}
            </div>
        )
    }
}